import { commonService } from "./common.service";
import { env } from "../env";

export const profilIcpeService = {
  getProfilIcpe
};

function getProfilIcpe() {
  const url = new URL(`${env.apiUrl}/profil-icpe`);

  return commonService.getRessource(url);
}
